"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyObject = void 0;
const stringifyObject = (obj, opts) => {
    try {
        return JSON.stringify(obj, (key, value) => (typeof value === 'bigint' ? value.toString() : value), opts?.space);
    }
    catch (err) {
        return `{Parsing Error}`;
    }
};
exports.stringifyObject = stringifyObject;
